import useFacilityData from "@usas/ui-web/state/facility/UseFacilityData";

const useFacilityAdd = () => {
  const { facilityState } = useFacilityData();

  return { facilityState };
};

export default useFacilityAdd;